import { sortRegionsByDecoratorPriority } from '@seddi/style-decoration';
const fit = (imageSize, targetSize) => {
    if (imageSize.x === 0 || imageSize.y === 0)
        return Object.assign({}, targetSize);
    const scale = Math.min(targetSize.x / imageSize.x, targetSize.y / imageSize.y);
    return { x: imageSize.x * scale, y: imageSize.y * scale };
};
export const findBestAvailableRegionForNewLogo = (regions, existingLogos = []) => {
    var _a;
    if (regions.length === 0)
        return undefined;
    const occupiedRegions = new Set(existingLogos.map(logo => logo.region));
    const sorted = sortRegionsByDecoratorPriority(regions.map(region => ({
        id: region.id,
        name: region.name,
        pieceName: region.pieceName,
        side: String(region.side),
        size: { x: region.size.x, y: region.size.y },
        transform: region.transform,
    })));
    for (const sortedRegion of sorted) {
        const region = regions.find(r => r.id === sortedRegion.id);
        if (region && !occupiedRegions.has(region.id)) {
            return region;
        }
    }
    return (_a = regions.find(r => { var _a; return r.id === ((_a = sorted[0]) === null || _a === void 0 ? void 0 : _a.id); })) !== null && _a !== void 0 ? _a : regions[0];
};
export const calculateLogoSizeForRegion = (imageSize, region, is2DProduct) => {
    const targetSize = is2DProduct
        ? { x: region.size.x * 0.25, y: region.size.y * 0.25 }
        : region.size;
    return fit(imageSize, targetSize);
};
export const calculateLogoSizeRetainingWidth = (imageSize, width) => {
    if (imageSize.x === 0) {
        return { x: width, y: width };
    }
    const ratio = imageSize.y / imageSize.x;
    return { x: width, y: width * ratio };
};
